import React, { useCallback } from 'react';
import { Icon } from '@fuxi/eevee-icon';
import { useNav, useShowTime } from '@/hooks';
import cx from './index.module.scss';

interface Props {
  title?: React.ReactNode;
  showBack?: boolean;
  showBorder?: boolean;
  backConfig?: {
    text?: string;
    action?: () => void;
  };
  saveAction?: () => void;
  textColor?: 'white' | 'black';
}

export const Timer = ({
  saveAction,
  weekText,
  minuteText,
}: {
  saveAction?: () => void;
  weekText: string;
  minuteText: string;
}) => {
  return (
    <div className={cx['time-text']} onClick={saveAction}>
      <div className={cx('week')}>{weekText}</div>
      <div className={cx('line')}>|</div>
      <div className={cx('minute')}>{minuteText}</div>
    </div>
  );
};

const Header: React.FC<Props> = ({
  title,
  backConfig,
  saveAction,
  showBack = true,
  showBorder = true,
  textColor = 'black',
}) => {
  const nav = useNav();
  const [weekText, minuteText] = useShowTime('星期dd&HH:mm')?.split('&') || [];

  const onBack = useCallback(() => {
    if (backConfig?.action) {
      backConfig.action();
    } else {
      nav(-1);
    }
  }, [backConfig, nav]);

  return (
    <div className={cx('header', { 'show-border': showBorder, 'text-white': textColor === 'white' })}>
      {showBack && (
        <div className={cx['back']} onClick={onBack}>
          <Icon name="arrow-back" />
          <span className={cx['back-text']}>{backConfig?.text || '返回'}</span>
        </div>
      )}
      <div className={cx['title']}>{title}</div>
      <Timer saveAction={saveAction} weekText={weekText} minuteText={minuteText} />
    </div>
  );
};

export default Header;
